import { createRouter, createWebHistory } from 'vue-router'
import { isAuthenticated, getTrocarSenha } from '@/services/auth.js'
import { PERFIS_INTERNOS, temAcessoARota, rotaInicialDoUsuario, ehCandidato } from '@/shared/permissoes.js'
import { pagamentoEstaPago } from '@/shared/situacaoPagamento.js'
import store from '@/store'

function contextoDaInscricao() {
  const inscricao = store.state.minhaInscricao;
  return {
    temEdital: !!inscricao.editalId,
    temInscricao: !!inscricao.inscricaoId,
    aceitouTermos: inscricao.aceiteTermos,
    etapaProcesso: inscricao.etapaProcesso,
  };
}

async function garantirContextoDaInscricao() {
  if (!ehCandidato()) return;
  if (store.state.minhaInscricao.carregada) return;
  try {
    await store.dispatch('recuperarInscricaoAtualCandidato');
  } catch {
    store.commit('LIMPAR_CONTEXTO_INSCRICAO');
  }
}

const ROTAS_BLOQUEADAS_DURANTE_PAGAMENTO = [
  'inscricao-dados-pessoais',
  'inscricao-locais-atendimento',
  'inscricao-formacao',
  'inscricao-experiencia',
];

const ROTAS_LIBERADAS_EM_REVISAO_PRIMEIRA_ETAPA = [
  'inscricao-dados-pessoais',
  'inscricao-locais-atendimento',
  'inscricao-formacao',
  'inscricao-experiencia',
];

function rotaBloqueadaPorPagamento(nomeRota) {
  const { pagamento, revisaoPrimeiraEtapaSolicitada } = store.state.minhaInscricao;
  if (!pagamento) return false;
  if (revisaoPrimeiraEtapaSolicitada && ROTAS_LIBERADAS_EM_REVISAO_PRIMEIRA_ETAPA.includes(nomeRota)) return false;
  // Documentos sempre acessÃ­veis: envio inicial, reenvio apÃ³s reprovaÃ§Ã£o ou substituiÃ§Ã£o solicitada.
  if (nomeRota === 'inscricao-documentos') return false;
  if (ROTAS_BLOQUEADAS_DURANTE_PAGAMENTO.includes(nomeRota)) return true;
  return pagamentoEstaPago(pagamento) && nomeRota === 'inscricao-pagamento';
}

const routes = [
  {
    path: '/',
    name: 'landing',
    component: () => import('../views/LandingView.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
    meta: { somenteVisitante: true },
  },
  {
    path: '/recuperar-senha',
    name: 'recuperar-senha',
    component: () => import('../views/RecuperarSenhaView.vue'),
    meta: { somenteVisitante: true },
  },
  {
    path: '/trocar-senha',
    name: 'trocar-senha-obrigatoria',
    component: () => import('../views/TrocarSenhaObrigatoriaView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/redefinir-senha',
    name: 'redefinir-senha',
    component: () => import('../views/RedefinirSenhaView.vue'),
    meta: { somenteVisitante: true },
  },
  {
    path: '/app',
    component: () => import('@/layouts/MainLayout.vue'),
    children: [
      { path: '', redirect: '/app/inscricoes' },
      {
        path: 'inscricoes',
        name: 'inscricoes',
        component: () => import('../views/InscricaoListagemView.vue'),
        meta: { requiresAuth: true, perfis: PERFIS_INTERNOS }
      },
      {
        path: 'inscricoes/:id',
        name: 'inscricao-detalhe',
        component: () => import('../views/InscricaoDetalheView.vue'),
        props: true,
        meta: { requiresAuth: true, perfis: PERFIS_INTERNOS }
      },
      {
        path: 'analise-documental',
        name: 'analise-documental',
        component: () => import('../views/AnaliseDocumentalListagemView.vue'),
        meta: { requiresAuth: true, perfis: PERFIS_INTERNOS }
      },
      {
        path: 'analise-documental/:id',
        name: 'analise-documental-detalhe',
        component: () => import('../views/AnaliseDocumentalDetalheView.vue'),
        props: true,
        meta: { requiresAuth: true, perfis: PERFIS_INTERNOS }
      },
      {
        path: 'pontuacao-documental',
        name: 'pontuacao-documental',
        component: () => import('../views/PontuacaoDocumentalListagemView.vue'),
        meta: { requiresAuth: true, perfis: PERFIS_INTERNOS }
      },
      {
        path: 'pontuacao-documental/metricas',
        name: 'pontuacao-documental-metricas',
        component: () => import('../views/PontuacaoDocumentalMetricasView.vue'),
        meta: { requiresAuth: true, perfis: PERFIS_INTERNOS }
      },
      {
        path: 'pontuacao-documental/:id',
        name: 'pontuacao-documental-detalhe',
        component: () => import('../views/PontuacaoDocumentalDetalheView.vue'),
        props: true,
        meta: { requiresAuth: true, perfis: PERFIS_INTERNOS }
      },
      {
        path: 'pagamentos',
        name: 'pagamentos',
        component: () => import('../views/PagamentosView.vue'),
        meta: { requiresAuth: true, perfis: PERFIS_INTERNOS }
      },
      {
        path: 'editais',
        name: 'editais',
        component: () => import('../views/EditalListagemView.vue'),
        meta: { requiresAuth: true, perfis: PERFIS_INTERNOS }
      },
      {
        path: 'editais/novo',
        name: 'edital-novo',
        component: () => import('../views/EditalCadastroView.vue'),
        meta: { requiresAuth: true, perfis: PERFIS_INTERNOS }
      },
      {
        path: 'editais/:id',
        name: 'edital-cadastro',
        component: () => import('../views/EditalCadastroView.vue'),
        props: true,
        meta: { requiresAuth: true, perfis: PERFIS_INTERNOS }
      },
      {
        path: 'tipos-documento',
        name: 'tipos-documento',
        component: () => import('../views/TipoDocumentoListagemView.vue'),
        meta: { requiresAuth: true, perfis: PERFIS_INTERNOS }
      },
      {
        path: 'homologacao',
        name: 'homologacao',
        component: () => import('../views/HomologacaoView.vue'),
        meta: { requiresAuth: true, perfis: PERFIS_INTERNOS }
      },
      {
        path: 'publicacoes',
        name: 'publicacoes',
        component: () => import('../views/PublicacaoView.vue'),
        meta: { requiresAuth: true, perfis: PERFIS_INTERNOS }
      },
      {
        path: 'comunicacoes',
        name: 'comunicacoes',
        component: () => import('../views/TemplateBaseView.vue'),
        meta: { requiresAuth: true, perfis: PERFIS_INTERNOS }
      },
      {
        path: 'auditoria',
        name: 'auditoria',
        component: () => import('../views/TemplateBaseView.vue'),
        meta: { requiresAuth: true, perfis: PERFIS_INTERNOS }
      },
      {
        path: 'usuarios',
        name: 'usuarios',
        component: () => import('../views/UsuarioView.vue'),
        meta: { requiresAuth: true, perfis: ['ADMIN_TI'] }
      },
    ]
  },
  {
    path: '/candidato',
    component: () => import('@/layouts/CandidatoLayout.vue'),
    children: [
      { path: '', redirect: '/candidato/login' },
      {
        path: 'edital',
        name: 'candidato-edital',
        component: () => import('../views/candidato/EditalPublicoView.vue')
      },
      {
        path: 'criar-conta',
        name: 'candidato-criar-conta',
        component: () => import('../views/candidato/CandidatoCriarContaView.vue'),
        meta: { somenteVisitante: true }
      },
      {
        path: 'login',
        name: 'candidato-login',
        component: () => import('../views/candidato/CandidatoLoginView.vue'),
        meta: { somenteVisitante: true }
      },
      {
        path: 'recuperar-senha',
        name: 'candidato-recuperar-senha',
        component: () => import('../views/candidato/CandidatoRecuperarSenhaView.vue')
      },
      {
        path: 'redefinir-senha',
        name: 'candidato-redefinir-senha',
        component: () => import('../views/candidato/CandidatoRedefinirSenhaView.vue')
      },
      {
        path: 'inscricao/especialidade',
        name: 'inscricao-especialidade',
        component: () => import('../views/candidato/InscricaoEspecialidadeView.vue'),
        meta: { requiresAuth: true, perfis: ['CANDIDATO'] }
      },
      {
        path: 'termos',
        name: 'candidato-termos',
        component: () => import('../views/candidato/TermosLgpdView.vue'),
        meta: { requiresAuth: true, perfis: ['CANDIDATO'] }
      },
      {
        path: 'inscricao/dados-pessoais',
        name: 'inscricao-dados-pessoais',
        component: () => import('../views/candidato/InscricaoDadosPessoaisView.vue'),
        meta: { requiresAuth: true, perfis: ['CANDIDATO'] }
      },
      {
        path: 'inscricao/locais-atendimento',
        name: 'inscricao-locais-atendimento',
        component: () => import('../views/candidato/InscricaoLocaisAtendimentoView.vue'),
        meta: { requiresAuth: true, perfis: ['CANDIDATO'] }
      },
      {
        path: 'inscricao/formacao',
        name: 'inscricao-formacao',
        component: () => import('../views/candidato/InscricaoFormacaoView.vue'),
        meta: { requiresAuth: true, perfis: ['CANDIDATO'] }
      },
      {
        path: 'inscricao/experiencia',
        name: 'inscricao-experiencia',
        component: () => import('../views/candidato/InscricaoExperienciaView.vue'),
        meta: { requiresAuth: true, perfis: ['CANDIDATO'] }
      },
      {
        path: 'inscricao/documentos',
        name: 'inscricao-documentos',
        component: () => import('../views/candidato/InscricaoDocumentosView.vue'),
        meta: { requiresAuth: true, perfis: ['CANDIDATO'] }
      },
      {
        path: 'inscricao/pagamento',
        name: 'inscricao-pagamento',
        component: () => import('../views/candidato/InscricaoPagamentoView.vue'),
        meta: { requiresAuth: true, perfis: ['CANDIDATO'] }
      },
      {
        path: 'acompanhamento',
        name: 'candidato-acompanhamento',
        component: () => import('../views/candidato/AcompanhamentoInscricaoView.vue'),
        meta: { requiresAuth: true, perfis: ['CANDIDATO'] }
      }
    ]
  }
]

const ALTURA_NAVBAR_PADRAO = 80;
const RESPIRO_ANCORA = 8;

function offsetDaAncora() {
  const navbar = document.querySelector('.pnc-navbar');
  if (!navbar) return ALTURA_NAVBAR_PADRAO;
  return navbar.offsetHeight + RESPIRO_ANCORA;
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) return { el: to.hash, top: offsetDaAncora(), behavior: 'smooth' };
    return { top: 0 };
  }
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.somenteVisitante && isAuthenticated()) {
    await garantirContextoDaInscricao();
    const destino = rotaInicialDoUsuario(contextoDaInscricao());
    next(destino === to.name ? undefined : { name: destino });
    return;
  }

  if (!to.matched.some(record => record.meta.requiresAuth)) {
    next();
    return;
  }

  if (!isAuthenticated()) {
    next({ name: to.path.startsWith('/candidato') ? 'candidato-login' : 'login' });
    return;
  }

  const precisaTrocarSenha = getTrocarSenha();
  if (precisaTrocarSenha && to.name !== 'trocar-senha-obrigatoria') {
    next({ name: 'trocar-senha-obrigatoria' });
    return;
  }

  await garantirContextoDaInscricao();

  if (to.name === 'trocar-senha-obrigatoria') {
    if (precisaTrocarSenha) {
      next();
      return;
    }
    next({ name: rotaInicialDoUsuario(contextoDaInscricao()) });
    return;
  }

  if (temAcessoARota(to)) {
    if (rotaBloqueadaPorPagamento(to.name)) {
      next({ name: 'candidato-acompanhamento' });
      return;
    }
    next();
    return;
  }

  const destino = rotaInicialDoUsuario(contextoDaInscricao());
  if (destino === to.name) {
    next({ name: 'login' });
    return;
  }
  next({ name: destino });
});

export default router
